import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 512"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M320 383.1c35.2.7 63.8-27.8 63.8-63.1s-28.6-63.8-63.8-64c-35.2.2-63.8 28.7-63.8 64s28.6 63.8 63.8 63.1m23.8 32.9h-47.5c-39.9 0-72.3 33.5-72.3 74.7 0 11.7 9.3 21.3 20.8 21.3h150.3c11.6 0 20.9-9.6 20.9-21.3 0-41.2-32.4-74.7-72.2-74.7m224 0h-47.5c-39.9 0-72.3 33.5-72.3 74.7 0 11.7 9.3 21.3 20.8 21.3h150.3c11.6 0 20.9-9.6 20.9-21.3 0-41.2-32.4-74.7-72.2-74.7M544 383.1c35.2.7 63.8-27.8 63.8-63.1s-28.6-63.8-63.8-64c-35.2.2-63.8 28.7-63.8 64s28.6 63.8 63.8 63.1m-448 0c35.2.7 63.8-27.8 63.8-63.1s-28.6-63.8-63.8-64c-35.22.2-63.79 28.7-63.79 64S60.78 383.8 96 383.1m23.8 32.9H72.3C32.42 416 0 449.5 0 490.7 0 502.4 9.34 512 20.83 512h150.3c11.57 0 20.87-9.6 20.87-21.3 0-41.2-32.4-74.7-72.2-74.7",
      style: {"fill":"var(--fa-primary-color, currentColor)","opacity":"var(--fa-primary-opacity, 1)"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M96 64h448v160c24.62 0 47 9.625 64 25V49.63C608 22.25 586.5 0 560 0H80C53.5 0 32 22.25 32 49.63v199.4c17-15.38 39.38-25 64-25z",
      style: {"fill":"var(--fa-secondary-color, currentColor)","opacity":"var(--fa-secondary-opacity, 0.4)"}
    }, null, -1)
  ])))
}
export default { render: render }